import { useActivation } from '@context/MobileOne';
import { NavigationPageTitle, ScrollToTop } from '@core/index';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { appButtonType } from '@utils/globalConstant';
import { ButtonPrimary } from '@core/ButtonPrimary';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { Ta11yText } from '@core/Ta11yText';

export function HowItWorks() {
  const { setStep9SubStep, setShowActivationHeader } = useActivation();

  // Const
  const text1Content = tA11y('ek_reg_auto_top_up_dtls_txt1');
  const text2Content = tA11y('ek_reg_auto_top_up_dtls_txt2');
  const buttonContent = tA11y('ek_reg_auto_top_up_btn1');

  const handleBackClick = () => {
    setStep9SubStep(0);
    setShowActivationHeader(true);
  };
  const handleClick = () => {
    setStep9SubStep(2);
    setShowActivationHeader(true);
  };

  return (
    <>
      <ScrollToTop>
        <div className="how-container min-dvh-100">
          <AppPageContentWrapper>
            <div className="w-100 pb-40">
              <NavigationPageTitle
                title="ek_reg_auto_top_up_dtls_hdl1"
                variant="lg"
                isBackButton
                onButtonClick={handleBackClick}
              />
            </div>
            <div className="w-100 pb-40">
              <Ta11yText
                tag="p"
                className="ek-copy-16-medium text-primary"
                textContent={text1Content}
              />
            </div>
            <div className="w-100 pb-40">
              <Ta11yText
                tag="p"
                className="ek-copy-16-medium text-primary"
                textContent={text2Content}
              />
            </div>

            <div className="w-100 justify-content-center">
              <div className="col-lg-6 col-10 px-0 mx-auto">
                <ButtonPrimary
                  buttonType={appButtonType.PRIMARY}
                  buttonContent={buttonContent}
                  onClick={handleClick}
                />
              </div>
            </div>
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default HowItWorks;
